var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "list-unstyled text-gray-500" },
    _vm._l(_vm.links, function (item) {
      return _c("UiNavbarItem", { key: item.label, attrs: { item: item } })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }